import LiquidationReviewCRDForm from 'features/LiquidationReview/pages/CRU';
import Layout from 'layout';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function LiquidationReviewFormCreateEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <LiquidationReviewCRDForm readOnly={false} />
      </Layout>
    </LayoutProvider>
  );
}
